module.exports = __webpack_public_path__ + "img/transnautica.1a809513.png";